import Vue from 'vue';
import { AUTH_LOGOUT } from '@/main/store/actionTypes';
import { loggedUser as loggedUserState } from '@/main/store/loggedUser';
import { httpRequest } from '../services/httpRequest';
const channel = new BroadcastChannel('sessionEnd');

type LoggedUserState = typeof loggedUserState;
type DmsSys = typeof loggedUserState.DmsSys;
type OrganizaceData = typeof loggedUserState.OrganizaceData;
type UzivatelData = typeof loggedUserState.UzivatelData;
type PracovnikData = typeof loggedUserState.PracovnikData;
type DiscountLimitConfigData = typeof loggedUserState.DiscountLimitConfigData;
type PrimitiveTypes = string | number | boolean | null;
type UserMenu = typeof loggedUserState.UserMenu;
type UserTabs = typeof loggedUserState.UserTabs;
type UserRoles = typeof loggedUserState.UserRoles;

export interface LoggedUserMethods {
	loggedUser: LoggedUserState;
	dmsSys: DmsSys;
	organizace: OrganizaceData;
	uzivatel: UzivatelData;
	pracovnik: PracovnikData;
	discountLimitConfig:DiscountLimitConfigData;
	userMenu: UserMenu;
	UserTabs:UserTabs;
	userRoles: UserRoles;

	canSelectProvozovna(this: Vue, provozovnaId: number): boolean;
	canUpdateProvozovna(this: Vue, provozovnaId: number): boolean;
	hasAuthorizationForSklad(this: Vue, skladOzn: number): boolean;
	hasAuthorizationForSkladNv(this: Vue, skladnvOzn: number): boolean;
	hasAuthorizationForSkladOv(this: Vue, skladovOzn: number): boolean;
	hasAuthorizationForSkladOstatni(this: Vue, skladostOzn: number): boolean;
	hasAuthorizationForSkladPneu(this: Vue, skladpneuOzn: number): boolean;
	hasAuthorizationForAutopujcovna(this: Vue, pujcovnaId: number): boolean;
	getDmsSysValue(this: Vue, key: string, defaultValue: PrimitiveTypes): PrimitiveTypes;
	logout(): void;
}

export const LoggedUserMixin = Vue.extend({
	name: 'LoggedUser',
	computed: {
		loggedUser(this: Vue) {
			return this.$store.state.loggedUser;
		},
		dmsSys(this: Vue) {
			return this.$store.state.loggedUser.DmsSys;
		},
		organizace(this: Vue) {
			return this.$store.state.loggedUser.OrganizaceData;
		},
		uzivatel(this: Vue) {
			return this.$store.state.loggedUser.UzivatelData;
		},
		pracovnik(this: Vue) {
			return this.$store.state.loggedUser.PracovnikData;
		},
		discountLimitConfig(this: Vue) {
			return this.$store.state.loggedUser.DiscountLimitConfigData;
		},
		userMenu(this: Vue) {
			return this.$store.state.loggedUser.UserMenu;
		},
		userRoles(this: Vue) {
			return this.$store.state.loggedUser.UserRoles;
		},
	},
	methods: {
		canSelectProvozovna(this: Vue, provozovnaId: number) {
			return this.$store.state.loggedUser.PracovnikProvSelect.some((id: number) => id === provozovnaId);
		},
		canUpdateProvozovna(this: Vue, provozovnaId: number) {
			return this.$store.state.loggedUser.PracovnikProvUpdate.some((id: number) => id === provozovnaId);
		},
		hasAuthorizationForSklad(this: Vue, skladOzn: number) {
			return this.$store.state.loggedUser.PracovnikData.OpravneniNaSklady.some((id: number) => id === skladOzn);
		},
		hasAuthorizationForSkladNv(this: Vue, skladnvOzn: number) {
			return this.$store.state.loggedUser.PracovnikData.OpravneniNaSkladyNv.some((id: number) => id === skladnvOzn);
		},
		hasAuthorizationForSkladOv(this: Vue, skladovOzn: number) {
			return this.$store.state.loggedUser.PracovnikData.OpravneniNaSkladyOv.some((id: number) => id === skladovOzn);
		},
		hasAuthorizationForSkladOstatni(this: Vue, skladostOzn: number) {
			return this.$store.state.loggedUser.PracovnikData.OpravneniNaSkladyOstatni.some((id: number) => id === skladostOzn);
		},
		hasAuthorizationForSkladPneu(this: Vue, skladpneuOzn: number) {
			return this.$store.state.loggedUser.PracovnikData.OpravneniNaSkladyPneu.some((id: number) => id === skladpneuOzn);
		},
		hasAuthorizationForAutopujcovna(this: Vue, pujcovnaId: number) {
			return this.$store.state.loggedUser.PracovnikData.OpravneniNaPujcovny.some((id: number) => id === pujcovnaId);
		},
		getDmsSysValue(this: Vue, key: string, defaultValue: PrimitiveTypes) {
			let value = this.$store.state.loggedUser.DmsSys[key];
			if (defaultValue !== undefined && (value === undefined || value === null)) {
				value = defaultValue;
			}
			return value;
		},
		async logout() {
			this.$store.dispatch(AUTH_LOGOUT);
            try { channel.postMessage({ type: 'sessionEnd', time: Date.now() }); } catch (e) { /* channel closed */ }
			window.location.href = '/session-over';
		},
	},
});

channel.onmessage = (e) => {
 if (e.data.type === 'sessionEnd'
    && sessionStorage.getItem('loggedIn') === 'true' && window.location.pathname !== '/session-over') {
	window.location.href = '/session-over';
  }
};
